import { from, Observable } from 'rxjs';
import axios, { AxiosResponse } from 'axios';
import { HttpParams, FetchHeaders } from './http.types';

const defaultHeaders: HeadersInit = { 'Content-Type': 'application/json' };

const defaultOptions: FetchHeaders = {
  useDefaultHeaders: true,
};

const HttpService = (params: HttpParams): Observable<AxiosResponse> => {
  const { url, options, fetchHeaders = defaultOptions } = params;
  const headers = fetchHeaders.useDefaultHeaders ? defaultHeaders : {};
  const mergeHeaders = options ? { ...headers, ...options.headers } : headers;

  return from(
    axios(url, {
      ...options,
      headers: mergeHeaders,
    }),
  );
};

export default HttpService;
